import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSnackbar } from "notistack";
import "./previewItem.css"; // Make sure to append the additional local styles below to this file
import AutoFixHighSharpIcon from "@mui/icons-material/AutoFixHighSharp";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import MoreHorizRoundedIcon from "@mui/icons-material/MoreHorizRounded";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import QrCode2OutlinedIcon from "@mui/icons-material/QrCode2Outlined";
import WarehouseOutlinedIcon from "@mui/icons-material/WarehouseOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import IsLoading from "../../../../../IsLoading";

let itemsData;
export default function PreviewItem({ handleSubNavigator }) {
  const companyData = useSelector(
    (state) => state.clientFunction?.companiesDB?.clientData,
  );
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [searchParams, setSearchParams] = useSearchParams();
   
  const [openSections, setOpenSections] = useState({
    inventory: true,
    pricing: true,
    units: false,
    tracking: false,
    reports: false,
    metadata: false,
  });

  const [copied, setCopied] = useState(false);

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const copySku = async () => {
    if (!itemsData?.sku) return;

    try {
      await navigator.clipboard.writeText(itemsData?.sku);
      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 1500);
    } catch (error) {
      console.error("Unable to copy SKU:", error?.code || "REQUEST_FAILED");
    }
  };

  const formatDate = (value) => {
    if (!value) return "Not available";

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return value;
    }

    return new Intl.DateTimeFormat("en-NG", {
      dateStyle: "medium",
      timeStyle: "short",
    }).format(date);
  };

  const formatNumber = (value) => {
    if (value === null || value === undefined || value === "") {
      return "—";
    }

    return new Intl.NumberFormat("en-NG").format(value);
  };

  const displayValue = (value) => {
    if (value === null || value === undefined || value === "") {
      return "Not configured";
    }

    return value;
  };

  const totalStock = (itemsData?.inventories || []).reduce(
    (total, inventory) => total + Number(inventory?.stock?.quantity || 0),
    0,
  );

  const totalSellingQuantity = (itemsData?.inventories || []).reduce(
    (total, inventory) =>
      total + Number(inventory?.stock?.sellingQuantity || 0),
    0,
  );

  const totalReserved = (itemsData?.inventories || []).reduce(
    (total, inventory) =>
      total + Number(inventory?.stock?.reservedQuantity || 0),
    0,
  );

  const isActive = itemsData?.status === "active";
  async function apiGetOneItems() {
    try {
      setLoading(true);
      const sku = searchParams.get("sku") || "";
      console.log(sku, companyData.clientId);
      if (!sku) {
        setLoading(false);
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/manage_items/client/${companyData?.clientId}/items-data/api-get-item-by-sku?sku=${sku}`,
      );

      if (response?.data?.status === 201) {
        itemsData = response.data.itemFound;
        console.log("PREVIEWED ITEM: ");
      } else {
        enqueueSnackbar(response?.data?.message || "Failed to fetch item", {
          variant: "error",
          autoHideDuration: 3000,
        });
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);

      console.log(error?.code || "REQUEST_FAILED");

      enqueueSnackbar(
        error?.response?.data?.message || "Server error while fetching item",
        {
          variant: "error",
          autoHideDuration: 3000,
        },
      );
    }
  }

  useEffect(() => {
    apiGetOneItems();
  }, []);
  return (
    <>
    {loading && <IsLoading/>}
    <div className="ItemPreviewPage">
      <div className="ItemPreviewContainer">
        {/* =====================================================
            HEADER
        ====================================================== */}

        <header className="ItemPreviewHeader fx fx-ac fx-jb">
          <div className="fx fx-ac space1">
            <div className="ItemPreviewHeaderIcon fx fx-ac fx-jc">
              <InsertDriveFileIcon />
            </div>

            <div className="fx fx-cl">
              <div className="ItemPreviewBreadcrumb fs2">
                Manage Items
                <span>/</span>
                Item Preview
              </div>

              <h1 className="ItemPreviewTitle">{displayValue(itemsData?.name)}</h1>

              <div className="fx fx-ac space">
                <span className="ItemPreviewType">
                  {displayValue(itemsData?.itemType)}
                </span>

                <span className="ItemPreviewDot" />

                <span className="ItemPreviewSku">
                  SKU: {displayValue(itemsData?.sku)}
                </span>
              </div>
            </div>
          </div>

          <div className="fx fx-ac space">
            <button
              type="button"
              className="ItemPreviewIconButton"
              title="Copy SKU"
              onClick={copySku}
            >
              <ContentCopyOutlinedIcon />

              <span>{copied ? "Copied" : "Copy SKU"}</span>
            </button>

            <button
              type="button"
              className="ItemPreviewSecondaryButton"
              onClick={() => {
                handleSubNavigator(
                  "edit-item-display",
                  "Edit item",
                  "Edit item",
                );
              }}
            >
              <EditOutlinedIcon />
              Edit Item
            </button>

            <button type="button" className="ItemPreviewMoreButton">
              <MoreHorizRoundedIcon />
            </button>
          </div>
        </header>

        {/* =====================================================
            MAIN ITEM HERO
        ====================================================== */}

        <section className="ItemHeroPanel">
          <div className="ItemHeroTop fx fx-jb">
            <div className="ItemHeroIdentity fx fx-ac space2">
              <div className="ItemHeroImage fx fx-ac fx-jc">
                {itemsData?.images?.length > 0 ? (
                  <img src={itemsData?.images[0]} alt={itemsData?.name || "Item"} />
                ) : (
                  <InsertDriveFileIcon />
                )}
              </div>

              <div className="fx fx-cl space">
                <div className="fx fx-ac space">
                  <span className="ItemStatusBadge">
                    <span className="ItemStatusIndicator" />
                    {displayValue(itemsData?.status)}
                  </span>

                  {itemsData?.trackInventory && (
                    <span className="ItemTrackingBadge">Inventory Tracked</span>
                  )}
                </div>

                <h2 className="ItemHeroName">{displayValue(itemsData?.name)}</h2>

                <p className="ItemHeroDescription">
                  {itemsData?.description
                    ? itemsData?.description
                    : "No item description has been provided for this product."}
                </p>

                <div className="fx fx-ac space1">
                  <span className="ItemMetaTag">
                    <CategoryOutlinedIcon />
                    {displayValue(itemsData?.categoryId)}
                  </span>

                  <span className="ItemMetaTag">
                    <StorefrontOutlinedIcon />
                    {displayValue(itemsData?.brand)}
                  </span>

                  <span className="ItemMetaTag">
                    <CalendarTodayOutlinedIcon />
                    Created {formatDate(itemsData?.createdAt)}
                  </span>
                </div>
              </div>
            </div>

            {/* PRICE */}

            <div className="ItemHeroPrice">
              <span className="ItemPriceLabel">Selling Price</span>

              <div className="fx fx-ae space">
                <span className="ItemCurrency">
                  {displayValue(itemsData?.pricing?.currency)}
                </span>

                <strong>{formatNumber(itemsData?.pricing?.sellingPrice)}</strong>
              </div>

              <span className="ItemCostLabel">
                Cost price{" "}
                <strong>
                  {displayValue(itemsData?.pricing?.currency)}{" "}
                  {formatNumber(itemsData?.pricing?.costPrice)}
                </strong>
              </span>
            </div>
          </div>

          {/* =================================================
              QUICK STATS
          ================================================== */}

          <div className="ItemQuickStats g g4">
            <div className="ItemQuickStat">
              <div className="ItemQuickStatIcon">
                <WarehouseOutlinedIcon />
              </div>

              <div className="fx fx-cl">
                <span>Total Stock</span>
                <strong>{formatNumber(totalStock)}</strong>
              </div>

              <small>{displayValue(itemsData?.units?.salesUnit)}</small>
            </div>

            <div className="ItemQuickStat">
              <div className="ItemQuickStatIcon">
                <LocalShippingOutlinedIcon />
              </div>

              <div className="fx fx-cl">
                <span>Sold</span>
                <strong>
                  {formatNumber(itemsData?.reports?.total_quantity_sold)}
                </strong>
              </div>

              <small>Total quantity</small>
            </div>

            <div className="ItemQuickStat">
              <div className="ItemQuickStatIcon">
                <PaymentsOutlinedIcon />
              </div>

              <div className="fx fx-cl">
                <span>Total Earned</span>
                <strong>
                  {displayValue(itemsData?.pricing?.currency)}{" "}
                  {formatNumber(itemsData?.reports?.total_earned)}
                </strong>
              </div>

              <small>Recorded sales</small>
            </div>

            <div className="ItemQuickStat">
              <div className="ItemQuickStatIcon">
                <AssessmentOutlinedIcon />
              </div>

              <div className="fx fx-cl">
                <span>Purchased</span>
                <strong>
                  {formatNumber(itemsData?.reports?.total_quantity_purchased)}
                </strong>
              </div>

              <small>Total quantity</small>
            </div>
          </div>
        </section>

        {/* =====================================================
            ITEM INFORMATION
        ====================================================== */}

        <main className="ItemContent">
          {/* INVENTORY */}

          <section className="ItemAccordion">
            <button
              type="button"
              className="ItemAccordionHeader fx fx-ac fx-jb"
              onClick={() => toggleSection("inventory")}
            >
              <div className="fx fx-ac space1">
                <div className="ItemAccordionIcon">
                  <WarehouseOutlinedIcon />
                </div>

                <div className="fx fx-cl">
                  <strong>Inventory Details</strong>
                  <span>Stock levels and warehouse inventory</span>
                </div>
              </div>

              <div className="fx fx-ac space">
                <span className="ItemAccordionCount">
                  {itemsData?.inventories?.length || 0} location
                  {itemsData?.inventories?.length === 1 ? "" : "s"}
                </span>

                <KeyboardArrowDownRoundedIcon
                  className={
                    openSections.inventory
                      ? "ItemAccordionArrow active"
                      : "ItemAccordionArrow"
                  }
                />
              </div>
            </button>

            {openSections.inventory && (
              <div className="ItemAccordionContent">
                <div className="InventoryOverview g g4">
                  <div className="InventoryMetric">
                    <span>Available Stock</span>
                    <strong>{formatNumber(totalStock)}</strong>
                  </div>

                  <div className="InventoryMetric">
                    <span>Reserved</span>
                    <strong>{formatNumber(totalReserved)}</strong>
                  </div>

                  <div className="InventoryMetric">
                    <span>Selling Quantity</span>
                    <strong>{formatNumber(totalSellingQuantity)}</strong>
                  </div>

                  <div className="InventoryMetric">
                    <span>Minimum Level</span>
                    <strong>
                      {formatNumber(itemsData?.inventories?.[0]?.stock?.minLevel)}
                    </strong>
                  </div>
                </div>

                <div className="InventoryTable">
                  <div className="InventoryTableHeader g g4">
                    <span>Inventory Location</span>
                    <span>Available</span>
                    <span>Reorder Level</span>
                    <span>Status</span>
                  </div>

                  {itemsData?.inventories?.map((inventory, index) => {
                    const stock = inventory?.stock || {};

                    const quantity = Number(stock?.quantity || 0);

                    const reorderLevel = Number(stock?.reorderLevel || 0);

                    const lowStock =
                      reorderLevel > 0 && quantity <= reorderLevel;

                    return (
                      <div
                        className="InventoryTableRow g g4"
                        key={inventory?.inventoryId || index}
                      >
                        <div className="fx fx-ac space">
                          <div className="WarehouseIcon">
                            <WarehouseOutlinedIcon />
                          </div>

                          <div className="fx fx-cl">
                            <strong>
                              {displayValue(inventory?.inventoryId)}
                            </strong>

                            <span>Inventory location</span>
                          </div>
                        </div>

                        <div className="InventoryQuantity">
                          <strong>{formatNumber(quantity)}</strong>

                          <span>{displayValue(itemsData?.units?.salesUnit)}</span>
                        </div>

                        <span className="InventoryReorder">
                          {formatNumber(stock?.reorderLevel)}
                        </span>

                        <span
                          className={
                            lowStock
                              ? "InventoryStatus low"
                              : "InventoryStatus good"
                          }
                        >
                          {lowStock ? (
                            <>
                              <WarningAmberRoundedIcon />
                              Low stock
                            </>
                          ) : (
                            <>
                              <CheckCircleOutlineRoundedIcon />
                              Healthy
                            </>
                          )}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </section>

          {/* PRICING */}

          <section className="ItemAccordion">
            <button
              type="button"
              className="ItemAccordionHeader fx fx-ac fx-jb"
              onClick={() => toggleSection("pricing")}
            >
              <div className="fx fx-ac space1">
                <div className="ItemAccordionIcon">
                  <PaymentsOutlinedIcon />
                </div>

                <div className="fx fx-cl">
                  <strong>Pricing & Tax</strong>
                  <span>Product pricing and tax configuration</span>
                </div>
              </div>

              <KeyboardArrowDownRoundedIcon
                className={
                  openSections.pricing
                    ? "ItemAccordionArrow active"
                    : "ItemAccordionArrow"
                }
              />
            </button>

            {openSections.pricing && (
              <div className="ItemAccordionContent">
                <div className="DetailGrid g g3">
                  <Detail
                    label="Cost Price"
                    value={`${displayValue(
                      itemsData?.pricing?.currency,
                    )} ${formatNumber(itemsData?.pricing?.costPrice)}`}
                  />

                  <Detail
                    label="Selling Price"
                    value={`${displayValue(
                      itemsData?.pricing?.currency,
                    )} ${formatNumber(itemsData?.pricing?.sellingPrice)}`}
                    highlight
                  />

                  <Detail
                    label="Tax Rate"
                    value={
                      itemsData?.pricing?.taxRate !== null
                        ? `${itemsData?.pricing.taxRate}%`
                        : "Not configured"
                    }
                  />

                  <Detail
                    label="Currency"
                    value={displayValue(itemsData?.pricing?.currency)}
                  />

                  <Detail
                    label="Profit Per Unit"
                    value={`${displayValue(
                      itemsData?.pricing?.currency,
                    )} ${formatNumber(
                      Number(itemsData?.pricing?.sellingPrice || 0) -
                        Number(itemsData?.pricing?.costPrice || 0),
                    )}`}
                    highlight
                  />

                  <Detail
                    label="Item Type"
                    value={displayValue(itemsData?.itemType)}
                  />
                </div>
              </div>
            )}
          </section>

          {/* UNITS */}

          <section className="ItemAccordion">
            <button
              type="button"
              className="ItemAccordionHeader fx fx-ac fx-jb"
              onClick={() => toggleSection("units")}
            >
              <div className="fx fx-ac space1">
                <div className="ItemAccordionIcon">
                  <SettingsOutlinedIcon />
                </div>

                <div className="fx fx-cl">
                  <strong>Units & Conversion</strong>
                  <span>Unit configuration for purchasing and sales</span>
                </div>
              </div>

              <KeyboardArrowDownRoundedIcon
                className={
                  openSections.units
                    ? "ItemAccordionArrow active"
                    : "ItemAccordionArrow"
                }
              />
            </button>

            {openSections.units && (
              <div className="ItemAccordionContent">
                <div className="DetailGrid g g3">
                  <Detail
                    label="Base Unit"
                    value={displayValue(itemsData?.units?.baseUnit)}
                  />

                  <Detail
                    label="Purchase Unit"
                    value={displayValue(itemsData?.units?.purchaseUnit)}
                  />

                  <Detail
                    label="Sales Unit"
                    value={displayValue(itemsData?.units?.salesUnit)}
                  />

                  <Detail
                    label="Conversion Rate"
                    value={displayValue(itemsData?.units?.conversionRate)}
                  />
                </div>
              </div>
            )}
          </section>

          {/* TRACKING */}

          <section className="ItemAccordion">
            <button
              type="button"
              className="ItemAccordionHeader fx fx-ac fx-jb"
              onClick={() => toggleSection("tracking")}
            >
              <div className="fx fx-ac space1">
                <div className="ItemAccordionIcon">
                  <QrCode2OutlinedIcon />
                </div>

                <div className="fx fx-cl">
                  <strong>Tracking & Identification</strong>
                  <span>Barcode, QR code and batch tracking</span>
                </div>
              </div>

              <KeyboardArrowDownRoundedIcon
                className={
                  openSections.tracking
                    ? "ItemAccordionArrow active"
                    : "ItemAccordionArrow"
                }
              />
            </button>

            {openSections.tracking && (
              <div className="ItemAccordionContent">
                <div className="IdentifierGrid g g2">
                  <div className="IdentifierCard">
                    <div className="IdentifierIcon">
                      <QrCode2OutlinedIcon />
                    </div>

                    <div className="fx fx-cl">
                      <span>Barcode</span>
                      <strong>{itemsData?.barcode || "Not assigned"}</strong>
                    </div>
                  </div>

                  <div className="IdentifierCard">
                    <div className="IdentifierIcon">
                      <QrCode2OutlinedIcon />
                    </div>

                    <div className="fx fx-cl">
                      <span>QR Code</span>
                      <strong>{itemsData?.qrcode || "Not assigned"}</strong>
                    </div>
                  </div>
                </div>

                {itemsData?.inventories?.map((inventory, index) => {
                  const tracking = inventory?.batchTracking || {};

                  return (
                    <div className="TrackingCard" key={index}>
                      <div className="fx fx-ac fx-jb">
                        <div className="fx fx-cl">
                          <strong>Batch Tracking</strong>

                          <span>
                            Inventory ID: {displayValue(inventory?.inventoryId)}
                          </span>
                        </div>

                        <span
                          className={
                            tracking?.batchTracking
                              ? "TrackingBadge enabled"
                              : "TrackingBadge"
                          }
                        >
                          {tracking?.batchTracking ? "Enabled" : "Disabled"}
                        </span>
                      </div>

                      <div className="DetailGrid g g3">
                        <Detail
                          label="Expiry Tracking"
                          value={
                            tracking?.expiryTracking ? "Enabled" : "Disabled"
                          }
                        />

                        <Detail
                          label="Tracking Method"
                          value={displayValue(tracking?.trackingMethod)}
                        />

                        <Detail
                          label="Batch Count"
                          value={formatNumber(tracking?.batches?.length)}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </section>

          {/* REPORTS */}

          <section className="ItemAccordion">
            <button
              type="button"
              className="ItemAccordionHeader fx fx-ac fx-jb"
              onClick={() => toggleSection("reports")}
            >
              <div className="fx fx-ac space1">
                <div className="ItemAccordionIcon">
                  <AssessmentOutlinedIcon />
                </div>

                <div className="fx fx-cl">
                  <strong>Item Performance</strong>
                  <span>Historical sales and purchasing statistics</span>
                </div>
              </div>

              <KeyboardArrowDownRoundedIcon
                className={
                  openSections.reports
                    ? "ItemAccordionArrow active"
                    : "ItemAccordionArrow"
                }
              />
            </button>

            {openSections.reports && (
              <div className="ItemAccordionContent">
                <div className="ReportGrid g g4">
                  <ReportMetric
                    label="Quantity Sold"
                    value={formatNumber(itemsData?.reports?.total_quantity_sold)}
                  />

                  <ReportMetric
                    label="Quantity Purchased"
                    value={formatNumber(
                      itemsData?.reports?.total_quantity_purchased,
                    )}
                  />

                  <ReportMetric
                    label="Total Earned"
                    value={`${displayValue(
                      itemsData?.pricing?.currency,
                    )} ${formatNumber(itemsData?.reports?.total_earned)}`}
                  />

                  <ReportMetric
                    label="Total Spent"
                    value={`${displayValue(
                      itemsData?.pricing?.currency,
                    )} ${formatNumber(itemsData?.reports?.total_spent)}`}
                  />
                </div>
              </div>
            )}
          </section>

          {/* METADATA */}

          <section className="ItemAccordion">
            <button
              type="button"
              className="ItemAccordionHeader fx fx-ac fx-jb"
              onClick={() => toggleSection("metadata")}
            >
              <div className="fx fx-ac space1">
                <div className="ItemAccordionIcon">
                  <SettingsOutlinedIcon />
                </div>

                <div className="fx fx-cl">
                  <strong>Item Metadata</strong>
                  <span>System and record information</span>
                </div>
              </div>

              <KeyboardArrowDownRoundedIcon
                className={
                  openSections.metadata
                    ? "ItemAccordionArrow active"
                    : "ItemAccordionArrow"
                }
              />
            </button>

            {openSections.metadata && (
              <div className="ItemAccordionContent">
                <div className="DetailGrid g g3">
                  <Detail label="Item ID" value={displayValue(itemsData?._id)} />

                  <Detail
                    label="Client ID"
                    value={displayValue(itemsData?.clientId)}
                  />

                  <Detail
                    label="Assigned To"
                    value={displayValue(itemsData?.assignedTo)}
                  />

                  <Detail
                    label="Created By"
                    value={displayValue(itemsData?.createdBy)}
                  />

                  <Detail
                    label="Updated By"
                    value={displayValue(itemsData?.updatedBy)}
                  />

                  <Detail
                    label="Created At"
                    value={formatDate(itemsData?.createdAt)}
                  />
                </div>
              </div>
            )}
          </section>
        </main>

        {/* =====================================================
            FOOTER
        ====================================================== */}

        <footer className="ItemPreviewFooter fx fx-jb fx-ac">
          <div className="fx fx-ac space">
            <div className="ItemFooterStatus">
              <span className="ItemStatusIndicator" />
              {isActive ? "Item is active" : "Item is inactive"}
            </div>

            <span className="ItemFooterDivider" />

            <span>Last updated {formatDate(itemsData?.updatedAt)}</span>
          </div>

          <div className="fx fx-ac space">
            <button
              type="button"
              className="ItemPreviewSecondaryButton"
              onClick={() => {
                handleSubNavigator(
                  "items",
                  "All Items",
                  "Items",
                );
              }}
            >
              Close
            </button>

            <button
              type="button"
              className="ItemPreviewPrimaryButton"
              onClick={() => {
                handleSubNavigator(
                  "edit-item-display",
                  "Edit item",
                  "Edit item",
                );
              }}
            >
              <EditOutlinedIcon />
              Edit Item
            </button>
          </div>
        </footer>
      </div>
    </div>
    </>
  );
}

/* =========================================================
   REUSABLE DETAIL COMPONENT
========================================================= */

const Detail = ({ label, value, highlight = false }) => {
  return (
    <div className={highlight ? "DetailItem highlight" : "DetailItem"}>
      <span>{label}</span>
      <strong>{value}</strong>
    </div>
  );
};

/* =========================================================
   REPORT METRIC
========================================================= */

const ReportMetric = ({ label, value }) => {
  return (
    <div className="ReportMetric">
      <span>{label}</span>
      <strong>{value}</strong>
    </div>
  );
};
